import { ModulesMap } from '@/config/data/modulesMaps'
import LandsApi from '@/services/apiServiceModules/landsApi'
import DataTransferModule from '@/services/dataTransferModule'

const landsApi = new LandsApi()

export default class LandsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LANDS, landsApi, { useCache: true })
	}
}
